module.exports = __webpack_public_path__ + "img/more.e8b45ac4.png";